import { render } from "./AiDSView.vue?vue&type=template&id=d2d5c1f0&scoped=true"
import script from "./AiDSView.vue?vue&type=script&lang=js"
export * from "./AiDSView.vue?vue&type=script&lang=js"

import "./AiDSView.vue?vue&type=style&index=0&id=d2d5c1f0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2d5c1f0"]])

export default __exports__